import { ReactNode } from 'react';

export enum TableColumnMappingType {
  NONE,
  AUTO,
  MANUAL,
  DISABLED,
}

export type Config = {
  configuredType: TableColumnMappingType;
  configuredTitle?: ReactNode;
  configuredError?: boolean;
};

export type ComplaintLevel = 'warn' | 'error';

export type DataValue = string | number | boolean;

export type TableColumn = {
  title: string;
  dataIndex: string;
  config: Config;
  hideConfig?: boolean;
  isConfigurableTable: boolean;
  hasActiveFilters: boolean;
  onConfirm?: () => void;
  onConfig?: () => void;
  onFilter: () => void;
  isHighlighted?: boolean;
};
